import './App.css';
import { Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import store from './store';
import { Provider } from 'react-redux'

import SignIn from 'Pages/SignIn';
import AdminSignIn from 'Pages/AdminSignIn';
import AdvisorRegistration from 'Pages/AdvisorRegistration';
import ClientRegistration from 'Pages/ClientRegistration';
import ForgetPassword from 'Pages/ForgetPasswordc';
import ChangePassword from 'Pages/ChangePassword';
import Pricing from 'Pages/Pricing';
import GlobalLoader from 'Components/GlobalLoader';
import Home from 'Pages/Home';
import ClientAndAdvisorOptions from 'Pages/ClientAndAdvisorOptions';
import LandingPage from 'Components/Landing';
import ContactUs from 'Pages/ContactUs';
import VerifyEmail from 'Pages/VerifyEmail';
import ResetPassword from 'Pages/ResetPassword';
import ConfirmReference from 'Pages/ConfirmReference';

function App() {
  return (
    <Provider store={store}>
      <GlobalLoader />
      <Routes>
        <Route path='*' element={<Navigate to={"/"} replace />} />
        <Route path="/" element={<LandingPage />} />
        <Route path="/registration-dashboard" element={<Home />} />
        <Route path="/subscription/:roleType" element={<ClientAndAdvisorOptions />} />
        <Route path="/sign-in/:type" element={<SignIn />} />
        <Route path="/a7f3d9e2-8b4c-4a1f-9e6d-2c8b5f7a3e1d/" element={<AdminSignIn />} />
        <Route path="/advisor-registration" element={<AdvisorRegistration />} />
        <Route path="/client-registration" element={<ClientRegistration />} />
        <Route path="/sign-in-step-2" element={<SignIn />} />
        <Route path="/forget-password/:userRole" element={<ForgetPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/pricing/:roleType/:subsType" element={<Pricing />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/confirm-reference" element={<ConfirmReference />} />
      </Routes>
      <ToastContainer theme='colored' autoClose={8000} bodyClassName="toastBody" limit={5} />
    </Provider>
  );
}

export default App;